import $$ from "cmn-utils";
/** 登录通用方法 */
const LoginUnit = {
  //退出登录
  Logout: () => {
    let out = () => {
      $$.clearStore();
      window.location.href = `${window.location.origin}/#/account/login`;
    };
    const headers = $$.getStore("headers");
    if (headers) {
      return $$.get("/oauth/logout", {}).then(() => out());
    } else {
      out();
    }
  },
};
export { LoginUnit };
